import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

/**
 * Singleton TanStack Router config — applied via `<RouterProvider router={router} />`
 * v `main.tsx`.
 *
 * Pending component: minimal "Načítám…" — admin/tenant shells mají vlastní
 * loading states v pozdějších fázích (Phase 8+ SSE spinner v sync UI).
 */
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 30_000,
  // Default scroll restoration nature on navigation.
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
